import { render, staticRenderFns } from "./StockPurchaseOrderListDiscrepancyPage.vue?vue&type=template&id=084cf77c&"
import script from "./StockPurchaseOrderListDiscrepancyPage.vue?vue&type=script&lang=js&"
export * from "./StockPurchaseOrderListDiscrepancyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports